import { MobileBaseField } from '../BaseField/models';
import { FormTableOfContentsSectionStat } from '../FormTableOfContents/models';

export const MobileSectionField = MobileBaseField.extend({
    /**
     * Get an array of fields living inside this section.
     */
    get_fields_in_section: function () {
        const section_field_ids = this.get_metadata_attribute('section_field_ids') || [];
        const fields = section_field_ids.map((id) => this.collection.get(id));

        return _.filter(fields, function (field) {
            if (!field) {
                console.warn('Field not found in the fields list.');
                return false;
            }
            return field.get('type') !== 'section';
        });
    },

    /**
     * Get count of visible values in section.
     */
    values_exist_in_section: function () {
        return this.collection.filter((field) => field.get('value'));
    },
    /**
     * Get count of visible sections
     *
     * @return Number of visible sections
     */
    count_visible_sections: function () {
        return this.collection.filter((field) => field.get('type') === 'section' && field.is_currently_hidden === false)
            .length;
    },

    // Hide this field - note that we unfortunately show via jquery dom manipulation here
    hide: function () {
        $(`#field_${this.get('id')}`)
            .parents('.form_section')
            .hide();
        this.is_currently_hidden = true;
        this.set('visible', false, { silent: true });
        this.get_fields_in_section().forEach((child) => child.hide());

        if (this.count_visible_sections() === 0) {
            this.collection.trigger('dynamicform:sections_hidden');
        }
    },

    // Show this field - note that we unfortunately show via jquery dom manipulation here
    show: function () {
        $(`#field_${this.get('id')}`)
            .parents('.form_section')
            .show();
        this.is_currently_hidden = false;
        this.set('visible', true, { silent: true });
        this.get_fields_in_section().forEach((child) => child.show());

        if (this.count_visible_sections() > 0) {
            this.collection.trigger('dynamicform:sections_visible');
        }
    },

    /**
     * Get the statistics of total, required, incomplete required fields remaining in this section.
     *
     * @return {FormTableOfContentsSectionStat} Stats for the section
     */
    get_stats: function () {
        var values = new FormTableOfContentsSectionStat({
            section: this,
            nesting_level: this.get_dependent_field_level()
        });

        const all_fields_in_section = this.get_fields_in_section();

        // Equipment and Ingredient temperature fields should include the individual items
        // and the follow up actions but not the field model itself.
        const fields_with_stats = all_fields_in_section.reduce((stat_fields, field) => {
            if (field.get('type') === 'ingredient_temperature' || field.get('type') === 'equipment_temperature') {
                const temperature_model_fields = field.get_temperature_field_child_models();
                stat_fields.push(...temperature_model_fields);
                return stat_fields;
            }
            stat_fields.push(field);
            return stat_fields;
        }, []);

        fields_with_stats.forEach(function (model) {
            // currently hidden fields are never required, so we don't have to worry about hidden fields
            if (model.is_currently_hidden || _.contains(['section', 'formula', 'instructions'], model.get('type'))) {
                return true;
            }
            values.plus_plus('num_total');
            if (model.has_value()) {
                values.plus_plus('num_complete');
            } else {
                values.plus_plus('num_incomplete');
            }

            // same rule the submit gate uses, so this count cannot disagree with it
            if (!model.is_effectively_required()) {
                values.plus_plus('num_optional');
                if (model.has_value()) {
                    values.plus_plus('num_optional_complete');
                } else {
                    values.plus_plus('num_optional_incomplete');
                }
                return;
            }

            values.plus_plus('num_required');
            if (model.has_value()) {
                values.plus_plus('num_required_complete');
            } else if (
                (model.get('type') === 'ingredient_temperature' && model.get('required') && !model.get('name')) ||
                (model.get('type') === 'equipment_temperature' && model.get('required') && !model.get('model_name'))
            ) {
                return true;
            } else {
                values.plus_plus('num_required_incomplete');
            }
        });

        return values;
    }
});
